import {
    BundleItemOption,
    PriceTypeEnum,
    CurrencyEnum
} from '@pylot-data/pylotschema.d'
import { formatPrice } from '@corratech/pylot-price'

export const getDynamicPriceToAdd = (
    option: BundleItemOption,
    dynamicPrice: boolean,
    currency: CurrencyEnum,
    locale: string,
    mainFinalPrice: number
) => {
    if (!dynamicPrice) {
        let price = option.price
        if (price && option.price_type === PriceTypeEnum.Percent) {
            price = mainFinalPrice * (price / 100)
        }

        if (price)
            return ` + ${formatPrice(
                {
                    value: option.price,
                    currency: currency
                },
                locale
            )}`
    }
    return ''
}
